import {
  GET_DISCUSSION,
  GET_DISCUSSION_USERS,
  CREATE_DISCUSSION,
  END_DISCUSSION,
  DISCUSSION_ERROR,
  CLEAR_DISCUSSION_USERS,
} from "../actions/types";

const initialState = {
  live: false,
  users: [],
  discussions: [],
  live_discussion: {},
  participant: {
    id: "",
    avatar: "",
    fistName: "",
    lastName: "",
  },
  userIndex: 0,
  count: 0,
  participantOneCountdown: 0,
  participantTwoCountdown: 0,
  participantThreeCountdown: 0,
  participantFourCountdown: 0,
  participantFiveCountdown: 0,
  participantSixCountdown: 0,
  participantSevenCountdown: 0,
  participantEightCountdown: 0,
  discussionJoined: false,
  room: "",
  imeBotAvi: "",
  loading: true,
  error: {},
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_DISCUSSION:
      return {
        ...state,
        live_discussion: payload,
        loading: false,
      };
    case GET_DISCUSSION_USERS:
      return {
        ...state,
        users: payload,
        loading: false,
      };
    case CREATE_DISCUSSION:
      return {
        ...state,
        live_discussion: payload,
        live: true,
      };
    case DISCUSSION_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    case CLEAR_DISCUSSION_USERS:
      return {
        ...state,
        users: [],
      };
    case END_DISCUSSION:
      return {
        ...state,
        live: false,
        users: [],
        live_discussion: {},
        loading: true,
        error: {},
      };
    default:
      return state;
  }
}
